import React from 'react';
import { FaFacebook, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { IoMdCall, IoMdClock } from 'react-icons/io';
import { MdEmail } from 'react-icons/md';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="relative">
      <div className="flex h-2 w-full flex-row sm:h-4 lg:h-6">
        <div
          className="size-full"
          style={{
            background:
              'var(--General-Gradient, linear-gradient(270deg, #0D695C 0%, #2A9C8E 24.48%, #E9C469 48.96%, #F4A261 73.44%, #E76F51 100%))',
          }}
        />
      </div>

      <footer className="bg-[#264653] px-6 py-10 text-[#F8F9FA] lg:px-60 lg:py-4">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-12 md:flex-row">
          <div className="flex flex-col gap-4 lg:gap-2">
            <img src="/images/logo-light.png" alt="EPC Builder Logo" className="mb-4 max-w-[240px] lg:max-w-[320px]" />
            <a
              href="mailto:info@epcbuilder.com"
              className="font-jost flex w-fit items-center gap-2 text-sm hover:text-[#A2D6CF]"
            >
              <MdEmail size="20px" /> info@epcbuilder.com
            </a>
            <a href="tel:08000584140" className="font-jost flex w-fit items-center gap-2 text-sm hover:text-[#A2D6CF]">
              <IoMdCall size="20px" /> 0800 058 4140
            </a>
            <div className="flex w-fit flex-row gap-2">
              <IoMdClock size="20px" />
              <p className="font-jost text-sm">Mon - Fri, 8am - 6pm</p>
            </div>
          </div>
          <div className="flex max-w-md flex-col justify-end gap-2">
            <div className="mt-4 flex gap-4 text-xl">
              <a
                href="https://www.facebook.com/TheImproveasyGroup/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#A2D6CF]"
              >
                <FaFacebook size="24px" />
              </a>
              <a
                href="https://www.linkedin.com/company/improveasy/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#A2D6CF]"
              >
                <FaLinkedinIn size="24px" />
              </a>
              <a
                href="https://twitter.com/ImproveasyGroup"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#A2D6CF]"
              >
                <FaXTwitter size="24px" />
              </a>
            </div>
          </div>
        </div>

        <hr className="my-6 border-white/20" />

        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 text-sm md:grid-cols-4">
          <div>
            <p className="font-jost mb-2 text-[14px] uppercase text-[#CBD3D6] lg:text-[16px]">Upgrade Services</p>
            <ul className="space-y-2">
              <li className="font-jost text-[14px]">
                <Link to="/install-measures" className="hover:text-[#A2D6CF]">
                  Home Upgrades We Offer
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/loft-insulation" className="hover:text-[#A2D6CF]">
                  Loft Insulation
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/cavity-wall-insulation" className="hover:text-[#A2D6CF]">
                  Cavity Wall Insulation
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/internal-wall-insulation" className="hover:text-[#A2D6CF]">
                  Internal Wall Insulation
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/roof-insulation" className="hover:text-[#A2D6CF]">
                  Room In Roof Insulation
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/solar-pv-system" className="hover:text-[#A2D6CF]">
                  Solar Panel PV
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-jost mb-2 text-[14px] uppercase text-[#CBD3D6] lg:text-[16px]">Plan Your Retrofit</p>
            <ul className="space-y-2">
              <li className="font-jost text-[14px]">
                <Link to="/what-to-expect" className="hover:text-[#A2D6CF]">
                  What To Expect
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/home-improvements" className="hover:text-[#A2D6CF]">
                  Explore Interactive House
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/your-savings" className="hover:text-[#A2D6CF]">
                  Your Savings
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/quick-wins" className="hover:text-[#A2D6CF]">
                  Quick Wins
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/finance-and-funding" className="hover:text-[#A2D6CF]">
                  Finance And Funding
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-jost mb-2 text-[14px] uppercase text-[#CBD3D6] lg:text-[16px]">Why Choose Us</p>
            <ul className="space-y-2">
              <li className="font-jost text-[14px]">
                <Link to="/who-we-are" className="hover:text-[#A2D6CF]">
                  Who We Are
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/quality-assurance" className="hover:text-[#A2D6CF]">
                  Quality Assurance
                </Link>
              </li>
              {/* <li className="font-jost text-[14px]">
                <Link to="/case-studies" className="hover:text-[#A2D6CF]">
                  Case Studies
                </Link>
              </li> */}
            </ul>
          </div>
          <div>
            <p className="font-jost mb-2 text-[14px] uppercase text-[#CBD3D6] lg:text-[16px]">Policies & Support</p>
            <ul className="space-y-2">
              <li className="font-jost text-[14px]">
                <Link to="/faq" className="hover:text-[#A2D6CF]">
                  FAQ
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/contactus" className="hover:text-[#A2D6CF]">
                  Contact Us
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/refund" className="hover:text-[#A2D6CF]">
                  Assessment Refund Policy
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/direct-debit-guarantee" className="hover:text-[#A2D6CF]">
                  Direct Debit Guarantee
                </Link>
              </li>
              <li className="font-jost text-[14px]">
                <Link to="/complaints" className="hover:text-[#A2D6CF]">
                  Complaints Handling Procedure
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <hr className="my-6 border-white/20" />
        <div className="mx-auto max-w-5xl space-y-1 text-center text-xs text-[#F8F9FA]">
          <p className="mb-6 text-[16px] lg:text-2xl">
            provided by{' '}
            <img
              src="/images/improveasy-light-logo.png"
              alt="Improveasy logo"
              className="ml-1 inline w-[130px] lg:w-52"
            />
          </p>
          <p className="text-[14px] text-[#CBD3D6]">
            © Copyright {new Date().getFullYear() || 2025} Improveasy Ltd |{' '}
            <Link to="/terms" className="underline hover:text-[#A2D6CF]">
              Terms & Conditions
            </Link>{' '}
            |{' '}
            <Link to="/privacy" className="underline hover:text-[#A2D6CF]">
              Privacy Policy
            </Link>
          </p>
          <p className="text-[14px] text-[#CBD3D6]">
            EPC Builder is a trading style of Improveasy (Installs) Ltd, a company registered in England and Wales (Co
            Reg No 10833883). Improveasy (Installs) Ltd is an Appointed Representative of Improveasy Ltd, a company
            registered in England and Wales (Co Reg No7807352). Registered Office: Station House, Stamford New Road,
            Altrincham, Cheshire, WA14 1EP. The firm is authorised and regulated by the Financial Conduct Authority
            (FRN708623) and offers credit facilities from a panel of lenders. A small fee is earned by Improveasy upon
            activation of a finance plan. The credit is subject to application and status.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
